module.exports = __webpack_public_path__ + "img/account.11247f2.png";